$.fn.PhotoPlace = function()
{
  var self = this;
  self.images = {};

  self.preload = function()
  {
    $('.projects__list .project a').each(function(){
      let id = $(this).data('id'),
        url = $(this).data('image');
      if (self.images['project'+id] == undefined){
        $('<img>').on('load', function(){
          self.images['project'+id] = $(this);
        }).attr("src", url);
      }
    });
  };

  self.place = function(id, url)
  {
    let previousImages = self.find('.place__image'),
      newImage = $('<img>');
    previousImages.fadeOut(250, function(){
      $(this).remove();
    });
    newImage.on('load', function(){
      let imageBox = $('<div class="place__image">').append(newImage).hide();
      self.find('.container').append(imageBox);
      imageBox.fadeIn(250);
    }).attr("src", url);
  };

  self.unplace = function()
  {
    let previousImages = self.find('.place__image');
    previousImages.fadeOut(250, function(){
      $(this).remove();
    });
  };

  return function()
  {
    self.addClass("place").append($('<div class="container">'));
    self.preload();
    return self;
  }();
};
